import { z } from 'zod';

export const StepDadosDoSeguroSchema = z.object({
  insuranceType: z.enum(['new', 'renewal']),
  congenere: z.string().optional(),
  policyNumber: z.string().optional(),
  useIndividualDocument: z.boolean(),
  documentNumber: z.string().min(1, 'Documento é obrigatório'),
  name: z.string().min(1, 'Nome é obrigatório'),
  businessSegment: z.string().min(1, 'Segmento é obrigatório'),
  businessCnae: z.string().min(1, 'CNAE é obrigatório'),
  averagePartnerAge: z.number().optional(),
  averageEmployeeAge: z.number().optional(),
  partnerCount: z.number().optional(),
  employeeCount: z.number().optional(),
  subStipulants: z
    .array(
      z.object({
        id: z.string(),
        useIndividualDocument: z.boolean(),
        documentNumber: z.string(),
        name: z.string(),
        segment: z.string().min(1, 'Segmento é obrigatório'),
        cnae: z.string().min(1, 'CNAE é obrigatório'),
        averagePartnerAge: z.number().optional(),
        averageEmployeeAge: z.number().optional(),
        partnerCount: z.number().optional(),
        employeeCount: z.number().optional(),
      })
    )
    .default([]),
});

export type StepDadosDoSeguroValues = z.infer<typeof StepDadosDoSeguroSchema>;
